'use client';

import type { I18nAdapter, RouterAdapter } from '@bomdisoft/webmcp-sdk';
import { useParams, usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useTransition } from 'react';

export function usePieleafWebMcpAdapters(): { router: RouterAdapter; i18n: I18nAdapter } {
  const nextRouter = useRouter();
  const pathname = usePathname() ?? '/';
  const searchParams = useSearchParams();
  const params = useParams();
  const [, startTransition] = useTransition();

  const locale = typeof params?.lang === 'string' ? params.lang : 'en';
  const search = searchParams?.toString() ?? '';

  const router: RouterAdapter = {
    pathname,
    push: useCallback(
      (url: string) => {
        startTransition(() => nextRouter.push(url));
      },
      [nextRouter],
    ),
    search,
  };

  const i18n: I18nAdapter = { locale };

  return { i18n, router };
}
